import { useMemo } from "react";
import Table from "../../components/common/table/Table";
import JsonFormsWrapper from "../../components/jsonForms/jsonFormsWrapper/JsonFormsWrapper";
import {
  MESSAGES,
  STORE_GROUP_HEADER_DATA,
  STYLES,
  TABLE_CONFIG,
} from "./storeConstants";
import { storeGroupFilterSchema, storeGroupFilterUISchema } from "./storeFormSchema";
import "./storeManagement.scss";
import { transformGroupsToRowData } from "./storeUtils";

const StoreGroupsTable = ({
  storeGroups,
  loading,
  statusFilter,
  onStatusFilterChange,
  onViewGroup,
  onEditGroup,
  onDeleteGroup,
}) => {
  const filterData = useMemo(() => ({ status: statusFilter }), [statusFilter]);

  // "All" means no status filter; ignore echoes of the current value.
  const handleFilterChange = (data) => {
    const next =
      data?.status === "ACTIVE" || data?.status === "INACTIVE"
        ? data.status
        : undefined;
    if (next !== statusFilter) onStatusFilterChange?.(next);
  };

  const rowData = transformGroupsToRowData(
    storeGroups,
    onViewGroup,
    onEditGroup,
    onDeleteGroup
  );

  return (
    <div className="store-groups-table-container stores-table-container">
      <div className="stores-table-header">
        <div className="filter-wrapper">
          <JsonFormsWrapper
            jsonschema={storeGroupFilterSchema}
            uischema={storeGroupFilterUISchema}
            data={filterData}
            onChange={handleFilterChange}
          />
        </div>
      </div>
      {loading ? (
        <div style={STYLES.loadingContainer}>{MESSAGES.LOADING}</div>
      ) : (
        <Table
          headerData={STORE_GROUP_HEADER_DATA}
          rowData={rowData}
          className="store-groups-table"
          pagination={true}
          rowsPerPage={TABLE_CONFIG.ROWS_PER_PAGE}
          noDataLabel="No store groups available"
        />
      )}
    </div>
  );
};

export default StoreGroupsTable;
